import { useEffect } from 'react';
import Intercom from './Intercom';

// Anonymous identity does not depend on form state. Initialize on mount,
// rather than booting Intercom again for every field edit or loading update.
export default function useAnonymousIntercom() {
  useEffect(() => {
    Intercom({ firstName: null, email: null });
  }, []);
}
